const CAREERS_OUR_VALUES = [
  {
    id: 0,
    title: 'THINK.',
    description:
      'We think critically, share different perspectives openly, question assumptions freely, and push each other every chance we get. ',
  },
  {
    id: 1,
    title: 'DO.',
    description:
      "We have a strong bias towards action, and we learn and adapt along the way. We don't get bogged down by indecision. We pick a lane and we hit the gas.",
  },
  {
    id: 2,
    title: 'SERVE.',
    description:
      'We are all about empowering others through service, because we believe that with service, trust and collaboration, anything is possible. ',
  },
];

export default CAREERS_OUR_VALUES;
